import './apps/bankrate-cookie'
